import React from "react";

// Uma escolha entre poucas opcoes que muda o que um cartao mostra (a metrica da evolucao, conversas ou
// pedidos de operador): botoes premidos num grupo, com o estilo dos periodos dos filtros. O mint e so
// para o que esta selecionado (spec do redesign, R1).
const Segmented = ({ label, options, value, onChange }) => (
  <div role="group" aria-label={label} className="inline-flex flex-wrap gap-1">
    {options.map((option) => {
      const pressed = option.value === value;
      return (
        <button
          key={option.value}
          type="button"
          aria-pressed={pressed}
          onClick={() => onChange(option.value)}
          className="px-2.5 py-1 text-xs rounded-md border whitespace-nowrap"
          style={{
            borderColor: pressed ? "var(--color-mint)" : "var(--color-border)",
            backgroundColor: pressed ? "var(--color-mint-muted)" : "var(--color-surface)",
            color: "var(--color-text-primary)",
            fontWeight: pressed ? 600 : 400,
          }}
        >
          {option.label}
        </button>
      );
    })}
  </div>
);

export default Segmented;
